export default __webpack_public_path__ + "static/media/mocha.2aa9195f.svg";